//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import navbar from '@/components/ui/navbar';
import cardbox from '@/components/ui/cardbox';

export default {
    name: 'divline',
    components: {navbar,cardbox},
	data() {
		return {

		}
	},
	mounted(){

	}
}



// WEBPACK FOOTER //
// ./src/views/member/integralRule.vue